import { render, staticRenderFns } from "./NumberFiveSVG.vue?vue&type=template&id=93562414&scoped=true&"
var script = {}


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93562414",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src3744633428/src/vbc-messaging-10-dlc-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('93562414')) {
      api.createRecord('93562414', component.options)
    } else {
      api.reload('93562414', component.options)
    }
    module.hot.accept("./NumberFiveSVG.vue?vue&type=template&id=93562414&scoped=true&", function () {
      api.rerender('93562414', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/assets/NumberFiveSVG.vue"
export default component.exports